import { FC } from 'react';

import lang from '../../../../lib/language';

import PhoneVerified from '../../../../assets/img/phone-verified.png';

import styles from './VerifiedPhoneModal.module.scss';

type Props = {};

const VerifiedPhoneModal: FC<Props> = (): JSX.Element => (
  <div className={styles.wrapper}>
    <img className={styles.verifiedImage} src={PhoneVerified} alt="confirm" />
    <span className={styles.title} id="verifiedPhoneTitle" aria-label="verify phone title">
      {lang.commonOnboardingPhoneVerificationPhoneNumberVerified()}
    </span>
    <span className={styles.text}>{lang.commonOnboardingPhoneVerificationCanContinueWithPlan()}</span>
  </div>
);

export default VerifiedPhoneModal;
